import type { ActivatedRouteSnapshot } from '@angular/router';

let searchParams = new URLSearchParams();

const SESSION_KEY = 'nr:initial-search-params';

export function captureInitialSearchParams(search: string): void {
  searchParams = new URLSearchParams(search);
}

export function getInitialSearchParam(key: string): string | null {
  return searchParams.get(key);
}

/** The Router drops query params on some launch URLs, so the raw ones captured at boot stand in. */
export function getQueryParam(route: ActivatedRouteSnapshot, key: string): string | null {
  const fromRoute: unknown = route.queryParams[key];
  return typeof fromRoute === 'string' ? fromRoute : getInitialSearchParam(key);
}

export function persistInitialSearchParams(): void {
  sessionStorage.setItem(SESSION_KEY, searchParams.toString());
}

export function restoreInitialSearchParams(): void {
  const stored = sessionStorage.getItem(SESSION_KEY);
  if (stored !== null) searchParams = new URLSearchParams(stored);
}
